"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogModifiers = exports.modalActions = void 0;
exports.modalActions = {
    ADD: 'add',
    EDIT: 'edit'
};
exports.catalogModifiers = {
    PRE_CART: 'PRE_CART',
    EXCLUDE_PILLOW_BUNDLES: 'EXCLUDE_PILLOW_BUNDLES',
    EXCLUDE_QUILT_SETS: 'EXCLUDE_QUILT_SETS',
    EXCLUDE_NON_ACTIVE: 'EXCLUDE_NON_ACTIVE',
    RANDOM_DEFAULT_SWATCH: 'RANDOM_DEFAULT_SWATCH'
};
//# sourceMappingURL=config.js.map